import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contact from '../views/contact.vue'
import NewList from '../views/newList.vue'
import NewDetail from '../views/newDetail.vue'
import About from '../views/about.vue'
import Serve from '../views/serve.vue'
import Programme from '../views/programme.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/newList',
    name: 'NewList',
    component: NewList
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path:'/newDetail',
    name:'NewDetail',
    component: NewDetail
  },{
    path:'/serve',
    name:'Serve',
    component:Serve
  },
  {
    path:'/Programme',
    name:'Programme',
    component:Programme
  },{
    path: '*',
    component: () => import('@/views/404'),
    name: '404',
    meta: { title: '404未找到' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
